import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
const Description = memo(
  ({ className, children }) => {
    const prefix = useClassNamePrefix();
    return /* @__PURE__ */ jsx("span", { className: classNames(`${prefix}description`, className), children });
  }
);
Description.displayName = "Description";
export {
  Description
};
//# sourceMappingURL=Description.js.map
